var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c('CurrentFilterList',{attrs:{"current-filters-list":_vm.getCurrentFilterListyByName(_vm.name),"level":2,"name":"hotel"},on:{"hover-block-name":function($event){return _vm.$emit('hover-block-name', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }